module.exports = __webpack_public_path__ + "ly.92b66622d3d85ad5ffd6.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ly.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ly.svg
// module chunks = styles